import React, { createContext } from 'react';
const centralStore = require('./stores/centralStore');
const RootComponent = require('../Root').default;

const _stores = [
  centralStore,
  //require('./stores/routeStore'),
  //require('../remove/notifStoreOld'),
  require('./stores/cxStore'),
  require('./stores/dataStore'),
  require('./stores/i18nStore'),
];

export const GrandsonContext = createContext();

const GrandsonProvider = ({ children, grandsonProps }) => {
  const memoizedProps = React.useMemo(() => grandsonProps, [grandsonProps]);

  return <GrandsonContext.Provider value={memoizedProps}>{children}</GrandsonContext.Provider>;
};
export default class FluxRouter extends React.Component {
  state = centralStore.getState();

  UNSAFE_componentWillMount() {
    _stores.forEach(store => {
      store.addChangeListener(this._handleStoreChange);
    });
  }

  componentWillUnmount() {
    _stores.forEach(store => {
      store.removeChangeListener(this._handleStoreChange);
    });
  }
  render() {
    //return <RootComponent {...this.state} />;

    return (
      <GrandsonProvider grandsonProps={this.state}>
        <RootComponent {...this.state} />
      </GrandsonProvider>
    );
  }

  _handleStoreChange = () => {
    try {
      this.setState(centralStore.getState());
    } catch (err) {
      console.error(err.stack);
      throw err;
    }
  };
}
